<template>
  <div class="cart" v-cloak>
      <div class="main">
        <form>
          <div class="list order edit-address">
            <ul>
              <li>
                <label>姓名</label>
                <div class="input-box">
                  <input v-model="addressee" @blur="inputBlur" @focus="inputFocus" placeholder="请输入您的姓名" :maxlength="6">
                </div>
              </li>
              <li>
                <div class="sex-box" style="margin-top: 0.3rem">
                  <label class="icon icon-boy" :class="{'checked': gender === '1'}">
                    <input type="radio" name="sex" v-model="gender" value="1" class="sex">男生
                  </label>
                  <label class="icon icon-girl" :class="{'checked': gender === '0'}">
                    <input type="radio" name="sex" v-model="gender" value="0" class="sex">女生
                  </label>
                </div>
              </li>
              <li>
                <label>电话</label>
                <div class="input-box">
                  <input v-model="mp" type="tel" @blur="inputBlur" @focus="inputFocus" placeholder="请输入您的手机号" :maxlength="11">
                </div>
              </li>
              <li v-if="!needBuilding">
                <a @click="chooseAddress" class="arrow-right">
                  <label>地址</label>
                  <div class="input-box">{{poi_address}}</div>
                </a>
              </li>
              <li v-if="needBuilding">
                <a @click="toggleBuildProp" class="arrow-right">
                  <label>楼栋</label>
                  <div class="input-box">{{buildInfo.name ? buildInfo.name : '请选择楼栋'}}</div>
                </a>
              </li>
              <!--<li v-if="buildInfo.name == '其他'">-->
                <!--<label style="width: 28%;">自定义楼栋</label>-->
                <!--<div style="width: 72%;" class="input-box">-->
                  <!--<input v-model="build_x_name" placeholder="例：梅园1号楼" :maxlength="11">-->
                <!--</div>-->
              <!--</li>-->
              <li v-if="needBuilding">
                <a @click="toggleFloorProp" class="arrow-right">
                  <label>楼层</label>
                  <div class="input-box">{{floorInfo.name ? floorInfo.name : '请选择楼层'}}</div>
                </a>
              </li>
              <!--<li v-if="needBuilding && (buildInfo.name == '其他' || floorInfo.name == '其他')">-->
                <!--<label style="width: 28%;">自定义楼层</label>-->
                <!--<div style="width: 72%;" class="input-box">-->
                  <!--<input v-model="floor_x_name" placeholder="例：1层" :maxlength="11">-->
                <!--</div>-->
              <!--</li>-->
              <li v-if="needBuilding">
                <a @click="toggleRoomProp" class="arrow-right">
                  <label>房间</label>
                  <div class="input-box">{{roomInfo.name ? roomInfo.name : '请选择房间'}}</div>
                </a>
              </li>
              <!--<li v-if="needBuilding && (buildInfo.name == '其他' || floorInfo.name == '其他' || roomInfo.name == '其他')">-->
                <!--<label style="width: 28%;">自定义房间</label>-->
                <!--<div style="width: 72%;" class="input-box">-->
                  <!--<input v-model="room_x_name" placeholder="例：101" :maxlength="11">-->
                <!--</div>-->
              <!--</li>-->
              <li v-if="!needBuilding">
                <label>详细</label>
                <div class="input-box">
                  <input v-model="detail" @blur="inputBlur" @focus="inputFocus" placeholder="请输入您的详细地址" :maxlength="30">
                </div>
              </li>
            </ul>
          </div>
        </form>
      </div>
      <footer class="block" style="width:100%;position: absolute;bottom: 0;left:0;right:0;"><a @click="saveAddress" class="btn btn-main btn-lg btn-block">保存</a></footer>

      <div class="mask" v-if="propShow" @click="closeProp"></div>
      <div class="prop-box" v-if="propBuildShow">
          <div class="title ac">{{buildTitle}}</div>
          <ul class="flex-ui item3" style="left: 0;right: 0;">
              <li v-for="item in buildingList" @click="changeBuilding(item)" :class="{'canSelect':item.id==buildInfo.id}">{{item.area}}</li>
          </ul>
      </div>
      <div class="prop-box" v-if="propFloorShow">
          <div class="title ac">{{floorTitle}}</div>
          <ul class="flex-ui item5" style="left: 0;right: 0;">
              <li v-for="item in floorList" class="ellipses" @click="changeFloor(item)" :class="{'canSelect':item.id==floorInfo.id}">{{item.area}}</li>
          </ul>
      </div>
      <div class="prop-box" v-if="propRoomShow">
          <div class="title ac">{{roomTitle}}</div>
          <ul class="flex-ui item5" style="left: 0;right: 0;">
              <li v-for="item in roomList" class="ellipses" @click="changeRoom(item)" :class="{'canSelect':item.id==roomInfo.id}">{{item.area}}</li>
            <!--<li v-if="isCustom" class="custom" :class="{'canSelect':roomInfo.id == -1}">-->
              <!--<input v-model="customRoomName" type="text" placeholder="自定义" maxlength="10" @focus="inputFocus" @blur="choseCustomRoom">-->
            <!--</li>-->
          </ul>
          <div class="custom" v-if="isCustom" @click="changeOpenCustom">
            没有找到自己房间号？点击这里添加
          </div>
      </div>
    <!--自定义房间号-->
    <div class="custom-pop" v-if="openCustomRoom">
      <div class="box">
        <div class="title">自定义房间号</div>
        <div class="input">
          <input v-model="customRoomName" autofocus type="text" placeholder="请输入你的房间号" maxlength="10">
        </div>
        <div class="tips">温馨提示：为确保餐品顺利送到，请填写真实房间号</div>
        <div class="">
          <div class="btn" @click="changeOpenCustom()">取消</div>
          <div class="btn btn-ok" @click="choseCustomRoom">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  // import { MessageBox } from 'mint-ui'

  export default {
    data () {
      return {
        isInit: true,
        propShow: false,
        propBuildShow: false,
        propFloorShow: false,
        propRoomShow: false,
        buildTitle: '请选择楼栋',
        floorTitle: '请选择楼层',
        roomTitle: '请选择房间',
        buildingList: [],
        floorList: [],
        roomList: [],
        build_x_name: null,
        floor_x_name: null,
        room_x_name: null,
        needBuilding: null,
        buildInfo: {
          name: undefined,
          id: undefined,
        },
        floorInfo: {
          name: undefined,
          id: undefined,
        },
        roomInfo: {
          name: undefined,
          id: undefined,
        },
        address_id: '',
        gender: '',
        addressee: '',
        mp: '',
        poi_address: '',
        detail: '',

        isCustom: false,
        openCustomRoom: false,
        customRoomName: '', // 自定义房间
      }
    },
    watch: {
      room_x_name: function (val) {
        this.room_x_name = val.replace(/\D/g, '')
      }
    },
    computed: {
      schoolInfo () {
        return this.$store.state.schoolInfo
      },
      wxUid () {
        return this.$store.state.wxUid
      },
    },
    created () {
      var _this = this;
      // document.title = '编辑收货地址';
      _this.address_id = window.localStorage.getItem('address-id');
      if(window.localStorage.getItem('addressInfo')) {
        var addressInfo = JSON.parse(window.localStorage.getItem('addressInfo'));
        // console.log(addressInfo)
        _this.gender = addressInfo.gender;
        _this.addressee = addressInfo.addressee;
        _this.mp = addressInfo.mp;
        _this.poi_address = addressInfo.poi_address;
        _this.detail = addressInfo.detail;
        _this.lon = addressInfo.lon;
        _this.lat = addressInfo.lat;
        _this.buildInfo.name = addressInfo.build_name;
        _this.buildInfo.id = addressInfo.build_id;
        _this.floorInfo.name = addressInfo.floor_name;
        _this.floorInfo.id = addressInfo.floor_id;
        _this.roomInfo.name = addressInfo.room_name;
        _this.roomInfo.id = addressInfo.room_id;
        // _this.build_x_name = addressInfo.build_x_name
        // _this.floor_x_name = addressInfo.floor_x_name
        // _this.room_x_name = addressInfo.room_x_name
        // if (_this.build_x_name) _this.buildInfo.name = '其他'
        // if (_this.floor_x_name) _this.floorInfo.name = '其他'
        // if (_this.room_x_name) _this.roomInfo.name = '其他'

        _this.getBuildingList();
        if(_this.buildInfo.build_name && _this.buildInfo.floor_name && _this.buildInfo.room_name){
          _this.getFloorList(1);
          _this.getRoomList();
        }
      } else {
        _this.postUserAddressInfo();
      }

    },
    methods: {
      closeProp () {
        this.propShow = false;
        this.propBuildShow = false;
        this.propFloorShow = false;
        this.propRoomShow = false;
      },
      clearInfo (type) {
        if (!type) {
          this.buildingList = []
          this.needBuilding = null
        }
        if (type == 2) {
          this.floorList = []
          this.floorInfo = {
            name: null,
            id: null
          }
        }
        this.roomList = [];
        this.roomInfo = {
          name: null,
          id: null
        }
      },
      getBuildingList () {
        let _this = this;
        let params = {
          school_id: this.$store.state.schoolInfo.schoolId
        }
        actions.postBuildList1(_this, params, data => {
          if (data && data.length > 0) {
            this.buildingList = data;
            this.needBuilding = data[0].area;
            // console.log(this.needBuilding)
          } else {
            this.clearInfo();
          }
        })
      },
      getFloorList (f) {
        let _this = this;
        let params = {
          school_id: this.$store.state.schoolInfo.schoolId,
          type: 2,
          code: this.buildInfo.id
        }
        actions.postBuildList1(_this, params, data => {
          if (data && data.length > 0) {
            this.floorList = data;
            if (!_this.isInit) this.propFloorShow = true;
            if(f){
              if(this.floorInfo.id){
                for(let v of data){
                  if(v.id == this.floorInfo.id && v.is_custom == 1){
                    this.isCustom = true;
                    if(this.roomInfo.id == -1){
                      this.customRoomName = this.roomInfo.name;
                    }
                    break;
                  }
                }
              }
            }
          } else {
            this.clearInfo(2);
            this.propShow = false;
          }
        })
      },
      getRoomList () {
        let _this = this;
        let params = {
          school_id: this.$store.state.schoolInfo.schoolId,
          type: 3,
          code: this.floorInfo.id
        }
        actions.postBuildList1(_this, params, data => {
          if (data && data.length > 0) {
            this.roomList = data;
            if (!_this.isInit) this.propRoomShow = true;
          } else {
            this.clearInfo(3);
            this.propShow = false;
          }
        })
      },
      toggleBuildProp () {
        if (!this.propShow) this.propShow = true;
        this.propBuildShow = !this.propBuildShow;
      },
      toggleFloorProp () {
        if (!this.propShow) this.propShow = true;
        this.propFloorShow = !this.propFloorShow;
      },
      toggleRoomProp () {
        if (!this.propShow) this.propShow = true;
        this.propRoomShow = !this.propRoomShow;
      },
      changeBuilding (item) {
        if (this.isInit) this.isInit = false;
        this.buildInfo.name = item.area;
        this.buildInfo.id = item.id;
        this.propBuildShow = false;
        this.clearInfo(2);
        this.getFloorList();
      },
      changeFloor (item) {
        if (this.isInit) this.isInit = false;
        this.floorInfo.name = item.area;
        this.floorInfo.id = item.id;
        this.propFloorShow = false;
        if(item.is_custom == 1){
          this.isCustom = true;
          this.customRoomName = '';
        }else{
          this.isCustom = false;
        }
        this.clearInfo(3);
        this.getRoomList();
      },
      changeRoom (item) {
        if (this.isInit) this.isInit = false;
        this.roomInfo.name = item.area;
        this.roomInfo.id = item.id;
        this.propRoomShow = false;
        this.propShow = false;
      },
      inputFocus:function () {
        // document.getElementsByTagName('footer')[0].classList.remove('fixed')
      },
      inputBlur:function () {
        // document.getElementsByTagName('footer')[0].classList.add('fixed')
      },
      chooseAddress: function () {
        var _this = this;
        var addressInfo = {};
        addressInfo.gender = _this.gender;
        addressInfo.addressee = _this.addressee;
        addressInfo.mp = _this.mp;
        addressInfo.poi_address = _this.poi_address;
        addressInfo.detail = _this.detail;
        addressInfo.lat = _this.lat;
        addressInfo.lon = _this.lon;
        addressInfo.build_name = _this.buildInfo.name;
        addressInfo.build_id = _this.buildInfo.id;
        addressInfo.floor_name = _this.floorInfo.name;
        addressInfo.floor_id = _this.floorInfo.id;
        addressInfo.room_name = _this.roomInfo.name;
        addressInfo.room_id = _this.roomInfo.id;
        // addressInfo.build_x_name = _this.build_x_name
        // addressInfo.floor_x_name = _this.floor_x_name
        // addressInfo.room_x_name = _this.room_x_name
        window.localStorage.setItem('addressInfo',JSON.stringify(addressInfo));
        _this.$router.push({path:'/chooseaddress'});
      },
      postUserAddressInfo: function () {
        var _this = this
        var params = {
          id: _this.address_id,
          school_id: this.$store.state.schoolInfo.schoolId
        }
        actions.postUserAddressInfo(_this, params, function (data) {
          _this.addressee = _this.$utils.Decrypt(data.addressee_encryption);
          _this.mp = _this.$utils.Decrypt(data.mp_encryption);
          if(data.gender === '男') {
            _this.gender = '1'
          } else {
            _this.gender = '0'
          }
          _this.poi_address = data.poi_address
          _this.detail = data.detail
          _this.lat = data.lat
          _this.lon = data.lon
          _this.buildInfo.name = data.build_name;
          _this.buildInfo.id = data.build_id;
          _this.floorInfo.name = data.floor_name;
          _this.floorInfo.id = data.floor_id;
          _this.roomInfo.name = data.room_name;
          _this.roomInfo.id = data.room_id;
          // _this.build_x_name = data.build_x_name
          // _this.floor_x_name = data.floor_x_name
          // _this.room_x_name = data.room_x_name
          if (data.isLimitFloor) {
            _this.getBuildingList();
            if(data.build_name && data.floor_name && data.room_name){
              _this.getFloorList(1);
              _this.getRoomList();
            }
            // if (_this.build_x_name) {
            //   _this.buildInfo.name = '其他'
            // } else {
            //   _this.getFloorList();
            // }
            // if (_this.floor_x_name) {
            //   _this.floorInfo.name = '其他'
            // } else {
            //   _this.getRoomList();
            // }
            // if (_this.room_x_name) _this.roomInfo.name = '其他'
          }
        })
      },
      // 保存编辑地址
      saveAddress: function () {
        var _this = this
        if (_this.addressee === '') {
          _this.$messagebox.alert('请输入您的姓名','')
          return false
        }
        if (_this.mp === '') {
          _this.$messagebox.alert('请输入您的手机号','')
          return false
        }else if(!(/^1\d{10}$/.test(_this.mp))){
          _this.$messagebox.alert('请输入正确格式的手机号','')
          return false
        }
        if(!_this.lon && !this.needBuilding){
          _this.$messagebox.alert('请选择地址','')
          return false
        }
        if (this.needBuilding) {
          if (!this.buildInfo.id) {
            return _this.$messagebox.alert('请选择楼栋')
          }
          // else if (this.buildInfo.name == '其他' && !this.build_x_name) {
          //   return _this.$messagebox.alert('请填写自定义楼栋')
          // }
          if (!this.floorInfo.id) {
            return _this.$messagebox.alert('请选择楼层');
          }
          // else if ((this.buildInfo.name == '其他' || this.floorInfo.name == '其他') && !this.floor_x_name) {
          //   return _this.$messagebox.alert('请填写自定义楼层')
          // }
          if (!this.roomInfo.id) {
            return _this.$messagebox.alert('请选择房间');
          }
          // else if ((this.buildInfo.name == '其他' || this.floorInfo.name == '其他' || this.roomInfo.name == '其他') && !this.floor_x_name) {
          //   return _this.$messagebox.alert('请填写自定义房间')
          // }
        }
        if (_this.detail === '' && !this.needBuilding) {
          _this.$messagebox.alert('请输入您的详细地址','')
          return false
        }
        var gender;
        if(_this.gender === '1') {
          gender = '男'
        } else {
          gender = '女'
        }
        var params = {
          id: _this.address_id,
          // school_id: _this.schoolInfo.schoolId,
          // addressee: _this.addressee,
          addressee_encryption: _this.$utils.Encrypt(_this.addressee),
          gender: gender,
          // mp: _this.mp,
          mp_encryption: _this.$utils.Encrypt(_this.mp),
          poi_address: _this.poi_address,
          detail: _this.detail,
          lon: _this.lon,
          lat: _this.lat,


          // build_x_name: _this.build_x_name,
          // floor_x_name: _this.floor_x_name,
          // room_x_name: _this.room_x_name,
          build_id: _this.buildInfo.id,
          build_name: _this.buildInfo.name,
          floor_id: _this.floorInfo.id,
          floor_name: _this.floorInfo.name,
          room_id: _this.roomInfo.id,
          room_name: _this.roomInfo.name,
          addressType: _this.needBuilding ? 1 : 0,
          is_build: _this.needBuilding ? 1 : 0,
        }

        // if (document.domain.indexOf('xiyoushi.com') >= 0) {
        //   params.school_id = 1826
        // } else {
        //   params.school_id = _this.schoolInfo.schoolId
        // }
        actions.postSaveAddress(_this, params, function () {
          // _this.$messagebox.alert('修改成功','')
          window.localStorage.removeItem('addressInfo');
          _this.$router.go(-1)
        }, function (data) {
          _this.$messagebox.alert(data.body.message,'')
        })
      },

      changeOpenCustom() {
        this.openCustomRoom = !this.openCustomRoom;
      },
      choseCustomRoom() {
        // document.getElementsByTagName('footer')[0].classList.add('fixed');
        if(!this.customRoomName || this.customRoomName.length == 0){
          this.$messagebox.alert('请输入你的房间号','');
          return;
        }
        this.roomInfo.id = -1;
        this.roomInfo.name = this.customRoomName;
        this.openCustomRoom = false;
        this.propRoomShow = false;
        this.propShow = false;
      }
    }
  }
</script>

<style scoped>
  .prop-box{
    z-index: 21;
    /*height: 6.6rem;*/
    background: #fff;
    padding-bottom: 0;
  }
  .flex-ui {
    /*display: flex;*/
    /*flex-wrap: wrap;*/
    width: 100%;
    height: 5rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    /*overflow: hidden;*/
    background: #fff;
  }
  .flex-ui li {
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #F5F5F5;
    border-radius: .08rem;
    margin: .2rem;
    padding: 0 .15rem !important;
    height: 1.2rem;
    font-size: .28rem;
    /*line-height: 1.2rem;*/
  }
  .flex-ui.item3 li {
    width: 30%;
    margin: 2% 0 0 2%;
    text-align: center;
    word-break: break-all;
  }
  .flex-ui.item5 li {
    width: 20.4%;
    height: .8rem;
    margin: .16rem 0 0 1.5%;
    text-align: center;
  }
  .custom{
    font-size: .28rem;
    font-weight: 400;
    color: #FF9A00;
    line-height: .28rem;
    background: #fff;
    text-align: center;
    padding: .32rem 0;
  }
  .canSelect{
    color: #999;
  }
  /*.flex-ui.item5 .custom input{*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*color: #a8a8a8;*/
    /*font-size: .26rem;*/
  /*}*/
  .custom-pop{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.4);
    z-index: 30;
  }
  .custom-pop .box{
    position: absolute;
    left: .75rem;
    right: .75rem;
    top: 30%;
    height: 3.72rem;
    background: #FFFFFF;
    border-radius: .16rem;
    padding: .32rem;
  }
  .custom-pop .box .title{
    font-size: .32rem;
    font-weight: 400;
    color: #333333;
    line-height: .36rem;
    text-align: center;
  }
  .custom-pop .box .input{
    width: 100%;
    height: .8rem;
    padding: .16rem;
    /*line-height: .8rem;*/
    background: #F5F5F5;
    border-radius: .08rem;
    margin: .32rem 0 .16rem 0;
  }
  .custom-pop .box input{
    font-size: .28rem;
    background: #F5F5F5;
    width: 80%;
    height: .48rem;
    line-height: .48rem;
  }
  .custom-pop .box input::placeholder{
    color: #999;
  }
  .custom-pop .box .tips{
    font-size: .2rem;
    font-weight: 400;
    color: #FF9A00;
    line-height: .28rem;
    padding-bottom: .32rem;
    text-align: center;
  }
  .custom-pop .box .btn{
    float: left;
    width: 2.4rem;
    height: .8rem;
    background: rgba(0, 0, 0, 0.05);
    border-radius: .08rem;
    margin-left: .18rem;
    font-size: .34rem;
    font-weight: 400;
    color: #333333;
  }
  .custom-pop .box .btn.btn-ok{
    background: linear-gradient(135deg, #FFEC00 0%, #FED400 100%);
  }
  .ellipses{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// EditAddress.vue?075af96d